import React from "react";
import { Row, Col } from "react-bootstrap";
import '../../../src/App.css';
import './FooterSection.css';
import logo_wo_brain from '../../assets/logo_without_brain.png';


const FooterSection = () => {
  return(
    <section className="marginTop5_per">
      <Row className="d-flex justify-content-center fondoFooter">
        <Col lg={10}>
          <Row>
            <Col lg={4} className="text-start">
              <Col lg={12}>
                <img src={logo_wo_brain} alt="logo-without-brain"/>
              </Col>
              <Col lg={12}>
                <p className="fs-7 text-copy-right-footer">
                  Copy@ 2024 DataDos. All Rights reserved
                </p>
              </Col>              
            </Col>            
          </Row>
        </Col>
      </Row>
      <Row>
        <Col lg={12} className="marginTopFooter"></Col>
      </Row>
    </section>
  );
};
export default FooterSection;